import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import api from "../../api";
import { useMediaQuery } from "react-responsive";

export default function MarketCapChart({ setDomincanceData }) {
  const [data, setData] = useState([]);
  const [latestdata, setLatestData] = useState({});
  const [fontSize, setFontSize] = useState(16);

  const fetchData = async () => {
    try {
      const resp = await api.getMarketCapHistory();
      console.log(resp);

      if (resp?.data) {
        const processedData = resp.data.map((item) => ({
          date: new Date(item.timestamp).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          }),
          marketCap: item.marketCap / 1e12, // convert to Trillions
          volume: item.volume / 1e9, // convert to Billions
        }));
        setData(processedData);
        setLatestData(resp?.latest);
        setDomincanceData(resp?.latest);
      }
    } catch (error) {
      console.error("Error fetching market cap data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function formatNumber(num) {
    const isNegative = num < 0;
    const absNum = Math.abs(num);

    let formatted;
    if (absNum >= 1_000_000_000_000) {
      formatted =
        (absNum / 1_000_000_000_000).toFixed(1).replace(/\.0$/, "") + "T";
    } else if (absNum >= 1_000_000_000) {
      formatted = (absNum / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (absNum >= 1_000_000) {
      formatted = (absNum / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (absNum >= 1_000) {
      formatted = (absNum / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      formatted = absNum.toString();
    }

    return isNegative ? `-${formatted}` : formatted;
  }

  // ✅ Custom tooltip handles missing volume gracefully
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const { marketCap, volume } = payload[0].payload;
      return (
        <div
          style={{ background: "#fff", border: "1px solid #ccc", padding: 10 }}
        >
          <p>
            <strong>{label}</strong>
          </p>
          <p>Market Cap: ${marketCap.toFixed(2)}T</p>
          {volume && <p>Volume: ${volume.toFixed(0)}B</p>}
        </div>
      );
    }
    return null;
  };

  const isSmall = useMediaQuery({
    query: "(max-width: 576px)",
  });

  return (
    <div className="grayCard mCapChart mCard mb-3">
      <div className="title mb-3">Crypto Market Cap</div>
      <div className="totalVolumeMain">
        <div className="col1">
          <div className="name">Market Cap</div>
          <div className="val">
            ${latestdata?.marketCap ? formatNumber(latestdata?.marketCap) : 0}
          </div>
        </div>
        <div>
          <div className="name">Volume</div>
          <div className="val">
            ${latestdata?.volume ? formatNumber(latestdata?.volume) : 0}
          </div>
        </div>
      </div>
      <div style={{ width: "100%", height: isSmall ? 300 : 400 }}>
        <ResponsiveContainer>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={{ fontSize: isSmall ? 13 : 16 }} />
            <YAxis
              tickFormatter={(v) => `$${v.toFixed(2)}T`}
              domain={["auto", "auto"]}
              tick={{ fontSize: isSmall ? 13 : 16 }}
            />
            <Tooltip content={<CustomTooltip />} />

            {/* ✅ Only Market Cap Line */}
            <Line
              type="monotone"
              dataKey="marketCap"
              stroke="#22c55e"
              strokeWidth={2}
              dot={false}
              name="Market Cap"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
